export type FileItem = string | File;
export type FileType = "image" | "video" | "audio" | "text" | "other";
export type MediaItem = {
  url: string;
  type: "image" | "video" | "audio" | "text" | "other";
  msgId?: string;
};

export const getFileType = (file: FileItem): FileType => {
  const textExtensions = [
    "txt",
    "log",
    "csv",
    "json",
    "xml",
    "html",
    "htm",
    "css",
    "js",
    "jsx",
    "ts",
    "tsx",
    "md",
    "ini",
    "yaml",
    "yml",
    "bat",
    "sh",
    "py",
    "php",
    "c",
    "cpp",
    "java",
    "rs",
    "go",
  ];

  if (typeof file === "string") {
    const lower = file.toLowerCase();
    
    if (/\.(jpg|jpeg|png|gif|webp|svg|bmp)$/.test(lower)) return "image";
    if (/\.(mp4|webm|mov|avi|mkv|flv)$/.test(lower)) return "video";
    if (/\.(mp3|wav|ogg|m4a|aac|flac)$/.test(lower)) return "audio";
    if (new RegExp(`\\.(${textExtensions.join("|")})$`).test(lower)) return "text";
    return "other";
  } else {
    const mime = file.type.toLowerCase();

    if (mime.startsWith("image/")) return "image";
    if (mime.startsWith("video/")) return "video";
    if (mime.startsWith("audio/")) return "audio";
    if (
      mime.startsWith("text/") ||
      mime === "application/json" ||
      mime === "application/xml" ||
      mime === "application/javascript" ||
      mime === "application/x-sh" ||
      mime === "application/x-httpd-php"
    ) {
      return "text";
    }
    return "other";
  }
};
